import { FC } from 'react';
import { PublicAttachmentUpload } from 'components/PublicAttachmentUpload';
import { PublicPage } from 'layouts/PublicPage';

export const PublicAttachmentUploadPage: FC = () => {
	return (
		<PublicPage title="Upload File">
			<PublicAttachmentUpload />
		</PublicPage>
	);
};
